import { Box, Typography } from '@material-ui/core';
import { appversion } from '../constants';

function LandingFooter() {
  return (
    <Box
      style={{
        marginTop: 30,
        display: 'flex',
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        direction: 'ltr',
      }}
    >
      <Typography component="span" style={{ fontSize: 22, color: '#bbb' }}>
        JADWAL.IO
      </Typography>
      <Typography
        component="span"
        style={{
          fontSize: 12,
          color: '#bbb',
          marginLeft: 2,
          marginRight: 2,
          marginTop: 6,
        }}
      >
        {appversion}
      </Typography>
    </Box>
  );
}

export default LandingFooter;
